// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__rNTZm","slider":"Switch_slider__3vJIR","round":"Switch_round__31yKU"};